<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <card card-body-classes="table-full-width" no-footer-line>
        <div class="row adaptive-margin mx-3 justify-content-between mb-2">
          <div class="d-flex flex-column  justify-content-start">
            <h4 class="card-title" style="margin-top: 0!important;">{{ locale.Days_off }}</h4>
          </div>
        </div>
        <template>
          <YearCalendar
              :lang="lang"
              :show-year-selector="true"
              v-model="year"
              :activeDates.sync="activeDates"
              @toggleDate="toggleDate"
              prefixClass="your_customized_wrapper_class"
              :activeClass="activeClass"
          ></YearCalendar>
        </template>
      </card>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn, Select, Option, Checkbox} from "element-ui";
// import {Pagination as NPagination} from "src/components";

import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import 'mapbox-gl/dist/mapbox-gl.css';
import YearCalendar from 'vue-material-year-calendar';
import  dayjs from 'dayjs';

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  components: {
    // NPagination,
    YearCalendar:YearCalendar,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      lang:process.env.VUE_APP_LOCALE,
      activeClass: 'selected-date',
      year: new Date().getFullYear(),
      activeDates: [
      ],




      locale: '',
    };
  },
  methods: {
    async getData() {
      await this.getWeekends();
    },
    toggleDate (dateInfo) {
      console.log(dateInfo.date);
      if (this.activeDates.find((e) => e.date===dateInfo.date)) {
        this.deleteWeekend(dateInfo.date);
      } else {
        this.createWeekend(dateInfo.date);
      }
      // this.createWeekend(dateInfo.date);
    },
    async getWeekends() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({})
      };
      return await fetch(url + '/get-weekends', requestOptions)
          .then(async response => {
            let data = await response.json();
            data = data[0];
            data.map((obj, i) => obj['className'] = 'selected-date')
            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }
            this.activeDates = data;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    },
    async createWeekend(date) {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({'day_off' : date})
      };
      return await fetch(url + '/add-weekend', requestOptions)
          .then(async response => {
            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    },
    async deleteWeekend(date) {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({'day_off' : date})
      };
      return await fetch(url + '/delete-weekend', requestOptions)
          .then(async response => {
            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    }
  },
  showYearSelector: {
    type: Boolean,
    default: () => true
  },
  // v-model="year"
  value: {
    type: [String, Number],
    default: dayjs().year()
  },
  prefixClass: {
    type: String,
    default: () => 'calendar--active'
  },
  hideWeekend: {
    type: Boolean,
    default: false
  },
  hideSunday: {
    type: Boolean,
    default: false
  },
  activeClass: {
    type: String,
    default: () => ''
  },
  activeDates: {
    type: Array,
    default: () => [],
    validator: (dateArray) => {
      let isGood = true
      let curDate = null
      dateArray.forEach(date => {
        if (typeof date === 'string') {
          curDate = date
        } else if (typeof date === 'object' && date.hasOwnProperty('date')) {
          curDate = date.date
        }
        if (!/^\d{4}\-\d{1,2}\-\d{1,2}$/.test(curDate)) {
          isGood = false
        }
        // Parse the date parts to integers
        var parts = curDate.split('-')
        var day = parseInt(parts[2], 10)
        var month = parseInt(parts[1], 10)
        var year = parseInt(parts[0], 10)
        if (year < 1000 || year > 3000 || month === 0 || month > 12) isGood = false
        let monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ]
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) monthLength[1] = 29
        if (!(day > 0 && day <= monthLength[month - 1])) isGood = false
      })
      return isGood
    }
  },
  created() {
    this.getData();
  },
  watch:{
    $route (to, from){
      this.for_which = Object.keys(to['query'])[0];
      window.location.reload();
    }
  },
  mounted() {
    this.locale = this.$getLocale();
    let query = window.location.search;
    const which = new URLSearchParams(query);
    this.for_which =  which.toString().slice(0, -1);
  }
  ,
}
;
</script>
<style scoped>
.card-body .vm--container {
  /*z-index: 9999999;*/
}

.close-modal-btn {
  position: absolute;
  top: 0;
  right: 1%;
}

.w-40 {
  width: 44.5%;
}

select {
  border-radius: 8px;
  background-color: white;
  height: 2rem;
}

input {
  border-radius: 8px;
  border: 1px solid grey;
  height: 2rem;
}

textarea {
  border-radius: 8px;
  border: 1px solid grey;
}

.show-map {
  background-image: url("../../../../public/img/icons/map-show.svg");
}

.hide-map {
  background-image: url("../../../../public/img/icons/map-hide.svg");
}


.mapboxgl-ctrl-geocoder {
  width: 480px;
  max-width: 480px !important;
}

.vm--container.scrollable::v-deep .vm--modal {
  height: auto !important;
  overflow:hidden!important;
}
.adaptive-row {
  display: flex;
  flex-direction: row;
}

@media (max-width: 600px) {
  .adaptive-row {
    display: flex;
    flex-direction: column;
    /*justify-content: center!important;*/
    align-items: center;
  }
}

.adaptive-row-child-width {
  width: 45%;
  margin-bottom: 1rem;
}

@media (max-width: 600px) {
  .adaptive-row-child-width {
    width: 100%;
    margin-bottom: 1rem;
  }
}

.report-form::v-deep .vm--modal {
  max-height: 230px;
}

.adaptive-worker-select-width {
  width: 95%;
}

@media (max-width: 600px) {
  .adaptive-worker-select-width {
    width: 100%;
  }
}

.adaptive-margin {
  margin-left: 1rem;
  margin-right: 1rem;
}

@media (max-width: 600px) {
  .adaptive-margin {
    margin-left: 0;
    margin-right: 0;
  }
}

.adaptive-justify-content {
  justify-content: space-around;
}

@media (max-width: 600px) {
  .adaptive-justify-content {
    justify-content: space-between;
  }
}

.over400 {
  display: inline;
}
.below400 {
  display: none;
}
@media screen and (max-width: 400px) {
  .over400 {
    display: none;
  }
  .below400 {
    display: inline;
  }
}

.el-table::v-deep td:first-child{
  z-index: 999;
  /*display: flex;*/
  /*flex-direction: row;*/
  /*flex-wrap: wrap;*/
}
</style>

<style>

.calendar {
  resize:none!important;
  min-width: 262px!important;
}

.selected-date {
  background-color:#00aca9!important;
  color: white;
}
</style>
